// Baghdad Sorting Center / Warehouse location
// This is the start/end location for all routes (pickups and RTOs)
export const BAGHDAD_WAREHOUSE = {
  name: 'Baghdad Sorting Center',
  lat: 33.284412,
  lng: 44.448563,
} as const;
